import getObject from "./get-object";

export default function getWithExpiry(key) {

    const object = getObject(key); 

    if (object == null) {
        return null;
    }

    if (new Date().getTime() > object.expiry) {
        localStorage.removeItem(key);
        return null;
    }

    return object.value;
}